import { j as l, I as r, d as t } from "./IconTemplate-5cea3f66.mjs";
import "react";
import "./internal.js";
const o = (a) => /* @__PURE__ */ l(r, { ...a, name: a.name || "Alarm", viewBox: "0 0 1024 1024", children: /* @__PURE__ */ l(
  "path",
  {
    d: "M362.5 99.47a43.89 43.89 0 0 1-22.68 57.79A431.91 431.91 0 0 0 153.6 313.71a43.89 43.89 0 0 1-73.14-48.57A519.68 519.68 0 0 1 304.71 76.8a43.89 43.89 0 0 1 57.79 22.67m299 0a43.89 43.89 0 0 1 57.79-22.67 519.68 519.68 0 0 1 224.25 188.34 43.89 43.89 0 1 1-73.14 48.57 431.91 431.91 0 0 0-186.22-156.53A43.89 43.89 0 0 1 661.5 99.4zM512 239.91a311.59 311.59 0 1 0 0 623.18 311.59 311.59 0 0 0 0-623.18M112.64 551.5a399.36 399.36 0 1 1 720.97 236.83l69.05 92.38a43.89 43.89 0 0 1-70.29 52.52l-59.4-79.43A397.82 397.82 0 0 1 512 950.86a397.9 397.9 0 0 1-260.97-97.06l-59.32 79.43a43.89 43.89 0 0 1-70.37-52.52l69.05-92.38a397.53 397.53 0 0 1-77.75-236.83M512 310.13a43.89 43.89 0 0 1 43.89 43.88v174.01l98.96 65.97a43.89 43.89 0 1 1-48.72 73L487.64 588a43.89 43.89 0 0 1-19.53-36.5V354.01A43.89 43.89 0 0 1 512 310.13",
    fill: "currentColor",
    fillOpacity: "0.9"
  }
) });
o.defaultProps = t;
export {
  o as default
};
